<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Gastos</span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('gastos.create')"
            dark
            color="#023145"
            width="140"
            class="float-right"
            @click="handleShowCreate"
          >
            Nuevo
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_area"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>
        <v-col cols="3" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('gastos.filters')"
            dark
            color="#023145"
            outlined
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
            Ver Filtros
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="gastos"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              :single-select="true"
              @item-selected="handleSelectItem"
            >
              <template v-slot:top>
                <div style="display: flex; justify-content:space-between">
                  <span
                    class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                  >
                    Todas las gastos
                  </span>
                  <div style="display: flex; align-items: center">
                    <!-- <label for="" style="margin-right: 10px; font-weight: bold"
                      >Tipo</label
                    >
                    <v-autocomplete
                      style="margin-right: 5px;"
                      v-model="form.type"
                      :items="type"
                      outlined
                      :item-text="customText"
                      item-value="id"
                      clearable
                      hide-details
                    ></v-autocomplete> -->
                  </div>
                </div>
                <v-divider></v-divider>
              </template>

              <template v-slot:item.igv="{ item }">
                <span v-if="item.category_gasto_type == 1">{{ item.igv }}</span>
                <span v-else>-</span>
              </template>

              <!-- <template v-slot:item.name="{ item }">
                <span class="font-weight-medium">{{ item.name }}</span>
                <span v-if="item.active" class="activo">
                  <v-icon size="11" color="#4CAF50">fas fa-check</v-icon>
                  activo
                </span>
                <span v-else class="inactivo">
                  <v-icon size="11" color="#F44336">fas fa-minus</v-icon>
                  inactivo
                </span>
                <br />
                <v-icon v-if="item.email" class="mr-1" size="13" color="#303197"
                  >fas fa-envelope</v-icon
                >
                <span class="font-italic email-company">
                  {{ item.email }}
                </span>
              </template> -->
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <div class="text-center">
      <v-bottom-sheet
        v-model="show_options_crud"
        :hide-overlay="true"
        persistent
        :retain-focus="false"
      >
        <v-sheet class="text-center" height="85px">
          <div class="py-3">
            <!-- <v-btn
              v-if="this.$hasPermision('gastos.edit')"
              class="mt-3"
              dark
              color="blue"
              outlined
              @click="handleEdit"
            >
              <v-icon class="mr-2" size="16">fas fa-pen</v-icon>
              Editar
            </v-btn> -->
            <!-- <v-btn
              v-if="
                show_btn_active && this.$hasPermision('gastos.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
              Activar
            </v-btn>
            <v-btn
              v-if="
                !show_btn_active && this.$hasPermision('gastos.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="amber"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
              Inactivar
            </v-btn> -->
            <!-- <v-btn
              v-if="this.$hasPermision('gastos.destroy')"
              class="ml-4 mt-3"
              dark
              color="red"
              outlined
              @click="handleDelete"
            >
              <v-icon class="mr-2" size="16">fas fa-times-circle</v-icon>
              Eliminar
            </v-btn> -->
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <Filters ref="filters"></Filters>
    <create-update ref="createUpdate"></create-update>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ArrayTools from "../../../helpers/ArrayTools";
import CreateUpdate from "../../../components/gasto/CreateUpdate";
import Filters from "../../../components/gasto/Filters";
import { Array } from "../../../helpers/Array";

export default {
  name: "Gasto",
  components: {
    Filters,
    CreateUpdate,
    OfficeLogin,
  },
  data() {
    return {
      search_area: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Logística",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "Fecha Emision", value: "date_emision" },
        { text: "Serie", value: "serie" },
        { text: "Correlativo", value: "correlative" },
        { text: "Categoria", value: "category_gasto_name" },
        { text: "Nombre", value: "name" },
        { text: "Documento", value: "document" },
        { text: "Origen", value: "origin" },
        { text: "Descuento", value: "discount" },
        { text: "IGV", value: "igv" },
        { text: "Total", value: "total" },
        { text: "Glosa", value: "glosa" },
      ],
      type: Array.categoriaGastoType,
      form: {
        type: 1,
      },
    };
  },
  computed: {
    ...mapState("gasto", ["gastos"]),
  },
  methods: {
    ...mapActions("gasto", ["getGastos", "change_status", "delete"]),
    ...mapActions("category-gasto", ["getCategoryGastos"]),
    ...mapActions("accounts", ["getAccounts"]),
    ...mapActions("employees", ["getAllWorkers"]),
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nuevo Gasto", "create");
    },
    handleEdit() {
      let gasto = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de gasto",
        "update",
        gasto
      );
    },
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de proveedores");
    },
    async getAllCategoryGastos() {
      await this.getGastos();
    },
    handleInputSearchByEnter(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        name: this.search_area,
      };
      await this.getGastos(filters);
    },
    async handleChangeStatus() {
      let gastos = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(gastos);
    },
    async handleDelete() {
      let gastos = this.selectedRows[0];
      await this.delete(gastos);
      this.selectedRows = [];
      this.showOptionCrud();
    },
  },
  created() {
    this.getAllCategoryGastos();
    this.getCategoryGastos();
    this.getAccounts();
    this.getAllWorkers();
  },
};
</script>

<style scoped></style>
